<template>
  <div>
    <add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      @refetch-data="refetchData"
      :tree-options="donVis"
      :list-role="listRole"
    />
    <edit
      :is-add-new-user-sidebar-active.sync="isEditUserSidebarActive"
      :user-data="curUserData"
      @refetch-data="refetchData"
      :list-role="listRole"
    />

    <!-- Filters -->
    <filters
      :don-vi-filter.sync="donViId"
      :tree-options="donVis"
      :status.sync="status"
    />

    <b-card no-body class="mb-0">
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Hiển thị</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>dòng</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="8">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block"
                placeholder="Tìm kiếm..."
              />
              <b-button
                v-if="$can('create', 'NGUOIDUNG')"
                class="ml-1"
                variant="primary"
                @click="isAddNewUserSidebarActive = showAddNewBox({})"
              >
                <!-- <feather-icon icon="PlusIcon" /> -->
                <span class="text-nowrap">Thêm người dùng</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="px-2">
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="fetchUsers"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="Không có dữ liệu"
          :sort-desc.sync="isSortDirDesc"
          table-class="vgt-table cs-table-info"
          style="min-height: 180px;"
        >
          <template #cell(index)="data">
            {{ data.index + (currentPage - 1) * perPage + 1 }}</template
          >
          <!-- Column: User -->
          <template #cell(user)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  :text="avatarText(data.item.fullName)"
                  class="cs-b-avatar"
                />
              </template>
              <b-link
                class="font-weight-bold d-block text-nowrap"
                @click="isEditUserSidebarActive = showEditBox(data.item)"
              >
                {{ data.item.fullName }}
              </b-link>
              <small class="text-muted">{{ data.item.userName }}</small>
            </b-media>
          </template>
          <template #cell(donVi)="data">
            <b-badge variant="light-success" class="text-capitalize">
              <p class="truncate1 mb-0">{{ data.value.ten }}</p>
            </b-badge>
          </template>
          <template #cell(unitRoleCode)="data">
            <b-badge
              :variant="`light-${resolveUserRoleVariant(data.value)}`"
              class="text-capitalize"
            >
              <p v-if="data.value" class="truncate1 mb-0">
                {{ resolveName(data.value) }}
              </p></b-badge
            >
          </template>
          <template #cell(isActived)="data">
            <b-badge
              :variant="`light-${resolveUserLockedVariant(data.value)}`"
              class="text-capitalize"
            >
              <p class="truncate1 mb-0">
                {{ resolveNameLock(data.value) }}
              </p></b-badge
            >
          </template>

          <!-- Column: isLock -->
          <!-- <template #cell(isLock)="data">
            <b-form-checkbox
              :checked="data.item.isLock"
              @click.native.stop
              @change="setLockUser($event, data.item)"
            />
          </template> -->

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="lockUser(data.item)">
                <div v-if="data.item.isActived">
                  <feather-icon icon="LockIcon" />
                  <span class="align-middle ml-50">Khóa tài khoản</span>
                </div>
                <div v-else>
                  <feather-icon icon="UnlockIcon" />
                  <span class="align-middle ml-50">Mở tài khoản</span>
                </div>
              </b-dropdown-item>
              <b-dropdown-item @click="resetPassword(data.item)">
                <feather-icon icon="RefreshCcwIcon" />
                <span class="align-middle ml-50">Mật khẩu mặc định</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$can('update', 'NGUOIDUNG')"
                @click="isEditUserSidebarActive = showEditBox(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Sửa</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="$can('delete', 'NGUOIDUNG')"
                @click="deleteUser(data.item)"
              >
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Xóa</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Hiển thị {{ dataMeta.from }} đến {{ dataMeta.to }} của
              {{ dataMeta.of }} dòng
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<ul id="vs43__listbox" role="listbox" tabindex="-1" class="vs__dropdown-menu">
<li role="option" id="vs43__option-0" aria-selected="true" class="vs__dropdown-option vs__dropdown-option--highlight">
  Thành phố Hà Nội
</li><li role="option" id="vs43__option-1" class="vs__dropdown-option">
  Tỉnh Hà Giang
</li><li role="option" id="vs43__option-2" class="vs__dropdown-option">
  Tỉnh Cao Bằng
</li><li role="option" id="vs43__option-3" class="vs__dropdown-option vs__dropdown-option--selected">
  Tỉnh Bắc Kạn
</li><li role="option" id="vs43__option-4" class="vs__dropdown-option">
  Tỉnh Tuyên Quang
</li><li role="option" id="vs43__option-5" class="vs__dropdown-option">
  Tỉnh Lào Cai
</li><li role="option" id="vs43__option-6" class="vs__dropdown-option">
  Tỉnh Điện Biên
</li><li role="option" id="vs43__option-7" class="vs__dropdown-option">
  Tỉnh Lai Châu
</li><li role="option" id="vs43__option-8" class="vs__dropdown-option">
  Tỉnh Sơn La
</li><li role="option" id="vs43__option-9" class="vs__dropdown-option">
  Tỉnh Yên Bái
</li><li role="option" id="vs43__option-10" class="vs__dropdown-option">
  Tỉnh Hoà Bình
</li><li role="option" id="vs43__option-11" class="vs__dropdown-option">
  Tỉnh Thái Nguyên
</li><li role="option" id="vs43__option-12" class="vs__dropdown-option">
  Tỉnh Lạng Sơn
</li><li role="option" id="vs43__option-13" class="vs__dropdown-option">
  Tỉnh Quảng Ninh
</li><li role="option" id="vs43__option-14" class="vs__dropdown-option">
  Tỉnh Bắc Giang
</li><li role="option" id="vs43__option-15" class="vs__dropdown-option">
  Tỉnh Phú Thọ
</li><li role="option" id="vs43__option-16" class="vs__dropdown-option">
  Tỉnh Vĩnh Phúc
</li><li role="option" id="vs43__option-17" class="vs__dropdown-option">
  Tỉnh Bắc Ninh
</li><li role="option" id="vs43__option-18" class="vs__dropdown-option">
  Tỉnh Hải Dương
</li><li role="option" id="vs43__option-19" class="vs__dropdown-option">
  Thành phố Hải Phòng
</li><li role="option" id="vs43__option-20" class="vs__dropdown-option">
  Tỉnh Hưng Yên
</li><li role="option" id="vs43__option-21" class="vs__dropdown-option">
  Tỉnh Thái Bình
</li><li role="option" id="vs43__option-22" class="vs__dropdown-option">
  Tỉnh Hà Nam
</li><li role="option" id="vs43__option-23" class="vs__dropdown-option">
  Tỉnh Nam Định
</li><li role="option" id="vs43__option-24" class="vs__dropdown-option">
  Tỉnh Ninh Bình
</li><li role="option" id="vs43__option-25" class="vs__dropdown-option">
  Tỉnh Thanh Hóa
</li><li role="option" id="vs43__option-26" class="vs__dropdown-option">
  Tỉnh Nghệ An
</li><li role="option" id="vs43__option-27" class="vs__dropdown-option">
  Tỉnh Hà Tĩnh
</li><li role="option" id="vs43__option-28" class="vs__dropdown-option">
  Tỉnh Quảng Bình
</li><li role="option" id="vs43__option-29" class="vs__dropdown-option">
  Tỉnh Quảng Trị
</li><li role="option" id="vs43__option-30" class="vs__dropdown-option">
  Tỉnh Thừa Thiên Huế
</li><li role="option" id="vs43__option-31" class="vs__dropdown-option">
  Thành phố Đà Nẵng
</li><li role="option" id="vs43__option-32" class="vs__dropdown-option">
  Tỉnh Quảng Nam
</li><li role="option" id="vs43__option-33" class="vs__dropdown-option">
  Tỉnh Quảng Ngãi
</li><li role="option" id="vs43__option-34" class="vs__dropdown-option">
  Tỉnh Bình Định
</li><li role="option" id="vs43__option-35" class="vs__dropdown-option">
  Tỉnh Phú Yên
</li><li role="option" id="vs43__option-36" class="vs__dropdown-option">
  Tỉnh Khánh Hòa
</li><li role="option" id="vs43__option-37" class="vs__dropdown-option">
  Tỉnh Ninh Thuận
</li><li role="option" id="vs43__option-38" class="vs__dropdown-option">
  Tỉnh Bình Thuận
</li><li role="option" id="vs43__option-39" class="vs__dropdown-option">
  Tỉnh Kon Tum
</li><li role="option" id="vs43__option-40" class="vs__dropdown-option">
  Tỉnh Gia Lai
</li><li role="option" id="vs43__option-41" class="vs__dropdown-option">
  Tỉnh Đắk Lắk
</li><li role="option" id="vs43__option-42" class="vs__dropdown-option">
  Tỉnh Đắk Nông
</li><li role="option" id="vs43__option-43" class="vs__dropdown-option">
  Tỉnh Lâm Đồng
</li><li role="option" id="vs43__option-44" class="vs__dropdown-option">
  Tỉnh Bình Phước
</li><li role="option" id="vs43__option-45" class="vs__dropdown-option">
  Tỉnh Tây Ninh
</li><li role="option" id="vs43__option-46" class="vs__dropdown-option">
  Tỉnh Bình Dương
</li><li role="option" id="vs43__option-47" class="vs__dropdown-option">
  Tỉnh Đồng Nai
</li><li role="option" id="vs43__option-48" class="vs__dropdown-option">
  Tỉnh Bà Rịa - Vũng Tàu
</li><li role="option" id="vs43__option-49" class="vs__dropdown-option">
  Thành phố Hồ Chí Minh
</li><li role="option" id="vs43__option-50" class="vs__dropdown-option">
  Tỉnh Long An
</li><li role="option" id="vs43__option-51" class="vs__dropdown-option">
  Tỉnh Tiền Giang
</li><li role="option" id="vs43__option-52" class="vs__dropdown-option">
  Tỉnh Bến Tre
</li><li role="option" id="vs43__option-53" class="vs__dropdown-option">
  Tỉnh Trà Vinh
</li><li role="option" id="vs43__option-54" class="vs__dropdown-option">
  Tỉnh Vĩnh Long
</li><li role="option" id="vs43__option-55" class="vs__dropdown-option">
  Tỉnh Đồng Tháp
</li><li role="option" id="vs43__option-56" class="vs__dropdown-option">
  Tỉnh An Giang
</li><li role="option" id="vs43__option-57" class="vs__dropdown-option">
  Tỉnh Kiên Giang
</li><li role="option" id="vs43__option-58" class="vs__dropdown-option">
  Thành phố Cần Thơ
</li><li role="option" id="vs43__option-59" class="vs__dropdown-option">
  Tỉnh Hậu Giang
</li><li role="option" id="vs43__option-60" class="vs__dropdown-option">
  Tỉnh Sóc Trăng
</li><li role="option" id="vs43__option-61" class="vs__dropdown-option">
  Tỉnh Bạc Liêu
</li><li role="option" id="vs43__option-62" class="vs__dropdown-option">
  Tỉnh Cà Mau
</li> <!----> </ul>

<script>
/* eslint-disable */
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  UserDelete,
  UserResetPassword,
  UserLock,
  GetDefaultPassword,
} from "@/services/api/DefaultTemplate/UserService";

import { useRouter } from "@core/utils/utils";
import LayoutData from "@/layouts/LayoutData";
import { GetByCurrentUser } from "@/services/api/DefaultTemplate/RoleService";

import useUsersList from "./useUsersList";
import Filters from "./components/Filters.vue";
import AddNew from "./components/AddNew.vue";
import Edit from "./components/Edit.vue";
export default {
  components: {
    Filters,
    AddNew,
    Edit,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  data() {
    return {
      defaultPassword: "",
      isWait: false,
      listRole: [],
    };
  },
  created() {
    this.getRoles();
    this.getDefaultPassword();
  },
  methods: { 
    getDefaultPassword(){
      GetDefaultPassword().then((res) => {
          this.defaultPassword = res.data;
        });
    },
    
    getRoles() {
      GetByCurrentUser().then((res) => {
        // console.log("res", res);
        this.listRole = res.data;
      });
    },
    resetPassword(user) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm(
            "Bạn chắc chắn muốn đặt mật khẩu lại mặc định: " + this.defaultPassword,
            {
              title: "Bạn chắc chứ?",
              size: "sm",
              okVariant: "primary",
              okTitle: "Lưu",
              cancelTitle: "Hủy",
              cancelVariant: "outline-secondary",
              hideHeaderClose: false,
              centered: true,
            }
          )
          .then((value) => {
            if (value) {
              this.isWait = true;
              UserResetPassword({ id: user.id }).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  // this.refetchData();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },

    lockUser(user) {
      var key = "mở";
      if (user.isActived == true) key = "khóa";
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Bạn chắc chắn muốn " + key + " tài khoản này?", {
            title: "Bạn chắc chứ?",
            size: "sm",
            okVariant: "primary",
            okTitle: "Lưu",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              UserLock({ id: user.id, isLock: !user.isActived }).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.refetchData();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },

    deleteUser(user) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Xác nhận xoá", {
            okTitle: "Đồng ý",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              UserDelete(user.id).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.refetchData();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
    showAddNewBox(user) {
      this.curUserData = JSON.parse(JSON.stringify(user));
      return true;
    },
    showEditBox(user) {
      this.curUserData = JSON.parse(JSON.stringify(user));
      return true;
    },
  },
  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Quản lý người dùng";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    const curUserData = {};
    const isAddNewUserSidebarActive = ref(false);
    const isEditUserSidebarActive = ref(false);

    const {
      fetchUsers,

      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      refUserListTable,
      refetchData,
      getDonVi,
      donViId,
      status,
      donVis,
      resolveUserLockedVariant,

      // lockFilter,
    } = useUsersList();

    const resolveName = (role) => {
      if (role != null && role) {
        if (role === "KT") return "Kiểm tra";
        if (role === "ND") return "Người dùng";
        if (role === "LDTDV") return "Quản trị đơn vị";
        if (role === "LDTPB") return "Quản trị phòng ban";
        if (role === "LDSNV") return "Lãnh đạo sở nội vụ";
        if (role === "ADMIN") return "Quản trị hệ thống";
        return "Người dùng";
      }
      return "Người dùng";
    };

    const resolveUserRoleVariant = (role) => {
      if (role != null && role) {
        if (role === "KT") return "info";
        if (role === "ND") return "primary";
        if (role === "LDTDV") return "warning";
        if (role === "LDTPB") return "success";
        if (role === "LDSNV") return "info";
        if (role === "ADMIN") return "danger";
        return "primary";
      }
      return "primary";
    };
    const resolveNameLock = (status) => {
      if (status == true) return "Đang hoạt động";
      // if (status === false) return "Đã khóa";
      return "Đã bị khóa";
    };
    return {
      headerData,

      curUserData,
      isAddNewUserSidebarActive,
      isEditUserSidebarActive,
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      getDonVi,
      donViId,
      status,
      donVis,
      avatarText,
      resolveName,
      resolveUserRoleVariant,
      resolveNameLock,

      resolveUserLockedVariant,

      // isLockOptions,
      // lockFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>
